export class TaskSchedule {
  employee: number;
  updateEmployeeOnWorklogItems: boolean;
  machine: number;
  attachments: number[];
  date: Date | string;
  time: string;
}
